/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginWithAuthCodeMutationVariables = Exact<{
  authenticationCode: string;
  email: string;
}>;


export type LoginWithAuthCodeMutation = { loginWithAuthCode: { access_token: string, token_type: string, expires_in: number, sendbird_access_token: string | null, refresh_token: string } | null };


export const LoginWithAuthCodeDocument = /*#__PURE__*/ gql`
    mutation LoginWithAuthCode($authenticationCode: String!, $email: String!) {
  loginWithAuthCode(authenticationCode: $authenticationCode, email: $email) {
    access_token
    token_type
    expires_in
    sendbird_access_token
    refresh_token
  }
}
    `;
export type LoginWithAuthCodeMutationFn = Apollo.MutationFunction<LoginWithAuthCodeMutation, LoginWithAuthCodeMutationVariables>;

/**
 * __useLoginWithAuthCodeMutation__
 *
 * To run a mutation, you first call `useLoginWithAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithAuthCodeMutation, { data, loading, error }] = useLoginWithAuthCodeMutation({
 *   variables: {
 *      authenticationCode: // value for 'authenticationCode'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginWithAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithAuthCodeMutation, LoginWithAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithAuthCodeMutation, LoginWithAuthCodeMutationVariables>(LoginWithAuthCodeDocument, options);
      }
export type LoginWithAuthCodeMutationHookResult = ReturnType<typeof useLoginWithAuthCodeMutation>;
export type LoginWithAuthCodeMutationResult = Apollo.MutationResult<LoginWithAuthCodeMutation>;
export type LoginWithAuthCodeMutationOptions = Apollo.BaseMutationOptions<LoginWithAuthCodeMutation, LoginWithAuthCodeMutationVariables>;